/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePtiRequest } from '../../models/create-pti-request';
import { CreatePtiResponse } from '../../models/create-pti-response';

export interface CreatePti$Params {
  body: CreatePtiRequest;
}

export function createPti(
  http: HttpClient,
  rootUrl: string,
  params: CreatePti$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<CreatePtiResponse>> {
  const rb = new RequestBuilder(rootUrl, createPti.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreatePtiResponse>;
    })
  );
}

createPti.PATH = '/v2/pti/create';
